var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMechanics = function SvgIconMechanics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1937_91941",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1937_91941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 22V19H4V17H20V19H13V22H11ZM9 11.5C9.28333 11.5 9.52083 11.4042 9.7125 11.2125C9.90417 11.0208 10 10.7833 10 10.5C10 10.2167 9.90417 9.97917 9.7125 9.7875C9.52083 9.59583 9.28333 9.5 9 9.5C8.71667 9.5 8.47917 9.59583 8.2875 9.7875C8.09583 9.97917 8 10.2167 8 10.5C8 10.7833 8.09583 11.0208 8.2875 11.2125C8.47917 11.4042 8.71667 11.5 9 11.5ZM15 11.5C15.2833 11.5 15.5208 11.4042 15.7125 11.2125C15.9042 11.0208 16 10.7833 16 10.5C16 10.2167 15.9042 9.97917 15.7125 9.7875C15.5208 9.59583 15.2833 9.5 15 9.5C14.7167 9.5 14.4792 9.59583 14.2875 9.7875C14.0958 9.97917 14 10.2167 14 10.5C14 10.7833 14.0958 11.0208 14.2875 11.2125C14.4792 11.4042 14.7167 11.5 15 11.5ZM5 8.6L6.65 3.8C6.73333 3.56667 6.87083 3.375 7.0625 3.225C7.25417 3.075 7.46667 3 7.7 3H16.3C16.5333 3 16.7458 3.075 16.9375 3.225C17.1292 3.375 17.2667 3.56667 17.35 3.8L19 8.6V15.2C19 15.4333 18.925 15.625 18.775 15.775C18.625 15.925 18.4333 16 18.2 16H17.8C17.5667 16 17.375 15.925 17.225 15.775C17.075 15.625 17 15.4333 17 15.2V14H7V15.2C7 15.4333 6.925 15.625 6.775 15.775C6.625 15.925 6.43333 16 6.2 16H5.8C5.56667 16 5.375 15.925 5.225 15.775C5.075 15.625 5 15.4333 5 15.2V8.6ZM7.65 7H16.35L15.65 5H8.35L7.65 7Z",
    fill: "#05072C"
  }))));
};
export default SvgIconMechanics;